import React from "react";
import PropTypes from "prop-types";
import Boleto from "./Boleto";
import ComplementaryBoleto from "./ComplementaryBoleto";
import { FieldSet, InputTypeText } from "../../elements";
import { Form } from "informed";
import Button from "../../v2/common/components/Button";
import ConfirmationModal from "../../components/ConfirmationModal";
import InputSelect from "../InputSelect";
import {
  createComplementaryBoleto,
  fetchFinancePlansOptions,
} from "../../services/finance_data_service";
import UploadArea from "../../elements/UploadArea";
import { toast } from "react-toastify";
import { batchVerifyRequiredValues } from "../../../lib/utils";
import { capitalize } from "lodash";


class ListBoleto extends React.Component {
  state = {
    showNewComplementaryBoletoModal: false,
    paymentPlanData: [],
    complementaryBoletoFormValues: {},
    files: [],
    formErrors: {
      due_day: "",
      due_year: "",
      due_month: "",
      value: "",
      reason: "",
      plan: "",
    },
  };

  days_options = Array.from({ length: 31 }, (_, i) => ({
    value: (i + 1).toString().padStart(2, "0"),
    label: (i + 1).toString().padStart(2, "0"),
  }));
  month_options = Array.from({ length: 12 }, (_, i) => ({
    value: (i + 1).toString().padStart(2, "0"),
    label: capitalize(
      new Intl.DateTimeFormat("pt-BR", { month: "long" }).format(
        new Date(2025, i)
      )
    ),
  }));

  actualYear = new Date().getFullYear();
  years_options = Array.from({ length: 2 }, (_, i) => ({
    value: (this.actualYear + i).toString(),
    label: (this.actualYear + i).toString(),
  }));
  today = new Date();
  verifyLastYearDay = this.today.getDate() == 31 && this.today.getMonth() == 11;

  formatAndSaveComplementaryBoleto = () => {
    const formData = this.state.complementaryBoletoFormValues;
    formData["due_date"] = `${formData["due_day"]}/${formData["due_month"]}/${
      formData["due_year"]
    }`;

    this.state.files.length > 0
      ? (formData["files"] = this.state.files)
      : (formData["files"] = null);
    let result = batchVerifyRequiredValues(formData, [
      "due_day",
      "due_year",
      "due_month",
      "value",
      "reason",
      "plan",
      "files",
    ]);

    if (!result.valid) {
      return this.setState((prevState) => ({
        ...prevState,
        formErrors: {
          ...prevState.formErrors,
          [result.field]: "Valor inserido inválido para este campo.",
        },
      }));
    }
    delete formData["due_year"];
    delete formData["due_day"];
    delete formData["due_month"];

    createComplementaryBoleto(
      this.state.formData,
      this.state.files,
      this.props.enrollmentToken
    );
  };

  async componentDidMount() {
    if (!this.verifyLastYearDay) {
      this.setState({
        complementaryBoletoFormValues: { due_year: this.actualYear },
      });
    }
    const { onboardingId } = this.props;
    if (onboardingId) {
      const data = await fetchFinancePlansOptions(onboardingId);
      this.setState({ paymentPlanData: data });
    }
  }
  render() {
    const {
      complementaryBoletos,
      boleto,
      resubmitting,
      onResubmit,
      showResubmit,
      canCreateComplementaryBoleto,
    } = this.props;

    const { showNewComplementaryBoletoModal } = this.state;

    return (
      <>
        <Boleto
          id={boleto}
          resubmitting={resubmitting}
          onResubmit={onResubmit}
          showResubmit={showResubmit}
        />
        {complementaryBoletos.length > 0 && (
          <>
            <FieldSet title="Boletos Complementares">
              {complementaryBoletos.map((complementaryBoleto) => (
                <ComplementaryBoleto
                  id={complementaryBoleto.boleto_id}
                  reason={complementaryBoleto.reason}
                />
              ))}
            </FieldSet>
          </>
        )}
        {canCreateComplementaryBoleto && (
            <div className="w-100 d-flex justify-content-end mt-3">
            <div className="col-md-4 p-0 offset-md-8 col-sm-12">
              <Button onClick={() => this.setState({ showNewComplementaryBoletoModal: true })}>
                Gerar boleto complementar
              </Button>
            </div>
          </div>
        )}
        <ConfirmationModal
          visible={showNewComplementaryBoletoModal}
          onCancel={() => this.setState({ showNewComplementaryBoletoModal: false })}
          onConfirm={() => this.formatAndSaveComplementaryBoleto()}
          showCloseButton={false}
          confirmText="Gerar boleto"
          cancelText="Cancelar"
          title="Gerar novo boleto complementar"
          width={1000}
          height={"auto"}
        >
          <Form
            id="dados-boleto"
            getApi={(api) => {
              this.formApi = api;
            }}
            style={{
              display: "flex",
              width: "100%",
              overflowY: "hidden",
              overflowX: "hidden",
              padding: "10px",
            }}
            onChange={(formState) =>
              formState.values &&
              this.setState((prevState) => ({
                complementaryBoletoFormValues: {
                  ...prevState.complementaryBoletoFormValues,
                  ...(formState.values || ""),
                },
              }))
            }
          >
            {({ formApi, formState }) => (
              <div
                style={{
                  width: "100%",
                  display: "grid",
                  gridTemplateColumns: "50% 50%",
                }}
              >
                <label
                  style={{
                    textAlign: "left",
                    width: "100%",
                    verticalAlign: "center",
                    fontSize: "20px",
                  }}
                >
                  Data de vencimento:
                </label>
                <div
                  style={{
                    width: "100%",
                    gridColumn: "span 2",
                    display: "grid",
                    gridTemplateColumns: "33% 33% 33%",
                    gap: "5px",
                    padding: "0px 5px",
                    zIndex: "100",
                  }}
                >
                  <InputSelect
                    required
                    error={this.state.formErrors["due_day"]}
                    options={this.days_options}
                    placeholder="Dia"
                    field="due_day"
                    name="due_day"
                    onChange={(e, { action }) => {
                      let value;
                      action == "clear" ? (value = "") : (value = e.value);
                      this.setState((prevState) => ({
                        complementaryBoletoFormValues: {
                          ...prevState.complementaryBoletoFormValues,
                          due_day: value,
                        },
                      }));
                    }}
                  />
                  <InputSelect
                    required
                    error={this.state.formErrors["due_month"]}
                    options={this.month_options}
                    placeholder="Mês"
                    field="due_month"
                    name="due_month"
                    onChange={(e) =>
                      this.setState((prevState) => ({
                        complementaryBoletoFormValues: {
                          ...prevState.complementaryBoletoFormValues,
                          due_month: e.value || "",
                        },
                      }))
                    }
                  />
                  <InputSelect
                    required
                    error={this.state.formErrors["due_year"]}
                    options={this.years_options}
                    placeholder={this.actualYear}
                    field="due_year"
                    name="due_year"
                    isDisabled={!this.verifyLastYearDay}
                    onChange={(e) =>
                      this.verifyLastYearDay &&
                      this.setState((prevState) => ({
                        complementaryBoletoFormValues: {
                          ...prevState.complementaryBoletoFormValues,
                          due_year: e.value || "",
                        },
                      }))
                    }
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    gridColumn: "span 2",
                    display: "grid",
                    gridTemplateColumns: "33% 33% 33%",
                    gap: "5px",
                    padding: "0px 5px",
                    zIndex: "10",
                  }}
                >
                  <InputTypeText
                    type="number"
                    label="Valor"
                    field="value"
                    required
                    name="value"
                    min={0}
                    error={this.state.formErrors["value"]}
                    onChange={(e) => {
                      if (parseInt(e.target.value) < 0) {
                        formApi.setValue("value", 0);
                        toast.info(
                          "Números negativos não são permitidos neste campo."
                        );
                      }
                      return e;
                    }}
                  />
                  <InputTypeText
                    error={this.state.formErrors["reason"]}
                    label="Razão"
                    required
                    field="reason"
                  />
                  <InputTypeText label="Autorizado por" field="authorized_by" />
                </div>
                <div style={{ gridColumn: "span 2", height: " 100px" }}>
                  <InputSelect
                    error={this.state.formErrors["plan"]}
                    options={this.state.paymentPlanData}
                    placeholder="Plano de pagamento"
                    field="plan"
                    name="plan"
                    required
                    onChange={(e) =>
                      this.setState((prevState) => ({
                        complementaryBoletoFormValues: {
                          ...prevState.complementaryBoletoFormValues,
                          plan: e.value || "",
                        },
                      }))
                    }
                  />
                </div>
                <div style={{ gridColumn: "span 2" }}>
                  <UploadArea
                    error={this.state.formErrors["files"]}
                    buttonLabel={"Autorização"}
                    onChange={(files) => this.setState({ files: files })}
                  />
                </div>
              </div>
            )}
          </Form>
        </ConfirmationModal>
      </>
    );
  }
}

ListBoleto.propTypes = {
  boleto: PropTypes.number,
  resubmitting: PropTypes.bool,
  onResubmit: PropTypes.func,
  showResubmit: PropTypes.bool,
  canCreateComplementaryBoleto: PropTypes.bool,
  complementaryBoletos: PropTypes.arrayOf(
    PropTypes.shape({
      boleto_id: PropTypes.number,
      reason: PropTypes.string,
    })
  ),
};

ListBoleto.defaultProps = {
  complementaryBoletos: [],
  canCreateComplementaryBoleto: false,
  boleto: undefined,
  showResubmit: false,
  onResubmit: () => null,
  resubmitting: false,
};

export default ListBoleto;
